export type AllergenKey = 'arachides' | 'noix' | 'crustaces' | 'lactose' | 'gluten' | 'oeufs' | 'soja' | 'poisson' | 'sesame';

export const ALLERGEN_KEYS: AllergenKey[] = [
  'arachides',
  'noix',
  'crustaces',
  'lactose',
  'gluten',
  'oeufs',
  'soja',
  'poisson',
  'sesame',
];

export interface AllergenDef {
  key: AllergenKey;
  label: { fr: string; en: string };
  article: { fr: string };
  terms: string[];
}

export const ALLERGENS: Record<AllergenKey, AllergenDef> = {
  arachides: {
    key: 'arachides',
    label: { fr: 'Arachides', en: 'Peanuts' },
    article: { fr: 'des' },
    terms: [
      'arachide',
      'arachides',
      'cacahuete',
      'cacahuetes',
      'peanut',
      'peanuts',
      'beurre d arachide',
      'beurre d arachides',
    ],
  },
  noix: {
    key: 'noix',
    label: { fr: 'Noix', en: 'Tree Nuts' },
    article: { fr: 'des' },
    terms: [
      'noix',
      'noisette',
      'noisettes',
      'amande',
      'amandes',
      'pacane',
      'pacanes',
      'pecan',
      'pecans',
      'cajou',
      'pistache',
      'pistaches',
      'walnut',
      'walnuts',
      'almond',
      'almonds',
      'hazelnut',
      'hazelnuts',
      'cashew',
      'cashews',
      'pistachio',
      'pistachios',
      'pignon',
      'pignons',
      'pine nut',
      'pine nuts',
    ],
  },
  crustaces: {
    key: 'crustaces',
    label: { fr: 'Crustacés', en: 'Shellfish' },
    article: { fr: 'des' },
    terms: [
      'crevette',
      'crevettes',
      'homard',
      'crabe',
      'langoustine',
      'langoustines',
      'ecrevisse',
      'ecrevisses',
      'shrimp',
      'shrimps',
      'prawn',
      'prawns',
      'lobster',
      'crab',
      'crayfish',
      'scampi',
    ],
  },
  lactose: {
    key: 'lactose',
    label: { fr: 'Lactose', en: 'Dairy' },
    article: { fr: 'du' },
    terms: [
      'lait',
      'creme',
      'fromage',
      'feta',
      'beurre',
      'yogourt',
      'yogurt',
      'yaourt',
      'parmesan',
      'mozzarella',
      'cheddar',
      'ricotta',
      'mascarpone',
      'gruyere',
      'brie',
      'chevre',
      'milk',
      'cream',
      'butter',
      'cheese',
      'ghee',
      'lait evapore',
      'lait concentre',
      // Cheeses whose name says "cheese" nowhere: a QA week served halloumi
      // wraps to a cook who had just declared a lactose allergy, and the list
      // was the reason — nothing else in that recipe read as dairy.
      'halloumi',
      'bocconcini',
      'burrata',
      'provolone',
      'gouda',
      'emmental',
      'comte',
      'camembert',
      'raclette',
      'paneer',
      'babeurre',
      'buttermilk',
      'tzatziki',
    ],
  },
  gluten: {
    key: 'gluten',
    label: { fr: 'Gluten', en: 'Gluten' },
    article: { fr: 'du' },
    terms: [
      'farine',
      'ble',
      'pates',
      'pain',
      'chapelure',
      'couscous',
      'orge',
      'seigle',
      'semoule',
      'boulgour',
      'flour',
      'wheat',
      'pasta',
      'bread',
      'breadcrumbs',
      'barley',
      'rye',
      'semolina',
      'bulgur',
      'spaghetti',
      'linguine',
      'penne',
      'macaroni',
      'nouilles',
      'noodles',
    ],
  },
  oeufs: {
    key: 'oeufs',
    label: { fr: 'Œufs', en: 'Eggs' },
    article: { fr: 'des' },
    terms: ['oeuf', 'oeufs', 'egg', 'eggs', 'mayonnaise'],
  },
  soja: {
    key: 'soja',
    label: { fr: 'Soja', en: 'Soy' },
    article: { fr: 'du' },
    terms: [
      'soja',
      'soya',
      'tofu',
      'tempeh',
      'edamame',
      'miso',
      'sauce soja',
      'sauce soya',
      'soy',
      'soy sauce',
      'tamari',
    ],
  },
  poisson: {
    key: 'poisson',
    label: { fr: 'Poisson', en: 'Fish' },
    article: { fr: 'du' },
    terms: [
      'poisson',
      'saumon',
      'morue',
      'thon',
      'truite',
      'tilapia',
      'aiglefin',
      'fletan',
      'sardine',
      'sardines',
      'anchois',
      'maquereau',
      'fish',
      'salmon',
      'cod',
      'tuna',
      'trout',
      'halibut',
      'haddock',
      'anchovy',
      'anchovies',
      'mackerel',
    ],
  },
  sesame: {
    key: 'sesame',
    label: { fr: 'Sésame', en: 'Sesame' },
    article: { fr: 'du' },
    terms: [
      'sesame',
      'tahini',
      'tahin',
      'graines de sesame',
      'sesame seeds',
      'sesame oil',
      'huile de sesame',
    ],
  },
};
